import { cn } from '@/lib/utils'

type StatusVariant = 'default' | 'success' | 'warning' | 'danger' | 'info'

interface StatusBadgeProps {
  children: React.ReactNode
  variant?: StatusVariant
  className?: string
}

// F02: Semantische Status-Tokens (kein Marken-Pastell). Textlabel bleibt
// immer sichtbar — Farbe ist nie der einzige Bedeutungsträger.
// Warning: volle Goldfläche + dunkler Text (gelb auf blassgelb war <4.5:1).
// Info: ruhige Sidebar-Accent-Fläche statt 10%-Blau-Tint (Smalltext-Grenze).
const VARIANTS: Record<StatusVariant, string> = {
  default: 'bg-muted text-foreground',
  success: 'bg-success/10 text-success border-success/20',
  warning: 'bg-warning text-warning-foreground border-warning/30',
  danger: 'bg-destructive/10 text-destructive border-destructive/20',
  info: 'bg-sidebar-accent text-sidebar-accent-foreground border-primary/20',
}

export function StatusBadge({ children, variant = 'default', className }: StatusBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium',
        VARIANTS[variant],
        className,
      )}
    >
      {children}
    </span>
  )
}
